import classNames from 'classnames';
import type * as React from 'react';
import type { CSSProperties } from 'react';
import { withAnimation } from 'react-with-animation';
import styles from './style.m.less';

const DEFAULT_FORM_ERROR_MESSAGE = 'Please check the fields that are marked above.';

type Props = {
    errorMessage: React.ReactNode;
    className?: string;
    style?: CSSProperties;
};

const FormErrorMessagePlain = ({ errorMessage, className, style }: Props) => (
    <div className={classNames(styles.errorMessage, className)} style={style} aria-label="Error Message">
        {errorMessage}
    </div>
);

export const FormErrorMessage = withAnimation(FormErrorMessagePlain);

FormErrorMessage.defaultProps = {
    errorMessage: DEFAULT_FORM_ERROR_MESSAGE,
    animationClasses: styles.errorMessageAnimation,
    animationDuration: 500,
    animateOnFirstRender: true,
};
